export const managementPhilosophy = {
  slogan: {
    en: 'Simple is ASTOC',
    main: '공간의 가치를 높이는 일, 사람을 향한 마음에서 시작됩니다.',
  },
  ceoMessage: {
    label: 'CEO MESSAGE',
    title: '고객의 신뢰가 곧 아스톡의 가치입니다',
    paragraphs: [
      '주식회사 아스톡은 부동산 자산의 생애 전 주기에 걸쳐 최상의 가치를 실현하는 것을 사명으로 삼고 있습니다. 건설사와 함께한 다수의 프로젝트 경험, 표준화된 관리 시스템, 그리고 분야별 전문 인력이 만들어내는 시너지를 통해 고객의 자산을 안전하게 지키고 그 가치를 키워왔습니다.',
      '우리는 단순히 건물을 관리하지 않습니다. 그 공간을 사용하는 사람들의 일상이 더 건강하고 쾌적해지도록, IT 솔루션과 전문 운영 노하우를 결합한 미래 지향적 관리 문화를 만들어갑니다. 아스톡의 모든 임직원은 고객과의 약속을 최우선의 가치로 여기며, 정직과 혁신으로 그 약속을 지켜나가겠습니다.',
    ],
    signature: '주식회사 아스톡 임직원 일동',
  },
  mission: {
    label: 'MISSION',
    title: '우리의 사명',
    slogan: 'Healthy & Comfortable Space',
    desc: '인류의 생활환경을 건강하고 쾌적하게 만듭니다. 아스톡은 IT 솔루션과 전문 운영 노하우를 결합하여 부동산의 가치를 극대화하고, 사람 중심의 공간 관리 문화를 선도합니다.',
  },
  vision: {
    label: 'VISION',
    title: '우리의 비전',
    slogan: 'No.1 Integrated Operation Partner',
    desc: '단순 시설 관리를 넘어 자산 가치를 창출하는 대한민국 대표 부동산 통합 운영 파트너로 도약합니다. 신뢰와 혁신을 바탕으로 고객과 함께 미래 지향적인 공간의 기준을 만들어갑니다.',
  },
  coreValues: [
    {
      no: '01',
      icon: '🤝',
      title: '신뢰 (Trust)',
      desc: '투명한 회계와 정직한 운영으로 고객과의 약속을 반드시 지킵니다. 모든 관리 내역을 수시로 검증하고 공개하여 객관성과 투명성을 확보합니다.',
    },
    {
      no: '02',
      icon: '💡',
      title: '혁신 (Innovation)',
      desc: '독자적인 IT 솔루션과 선진 관리 기법으로 끊임없이 새로운 가치를 창출합니다. 통합 구매관리 시스템으로 비용을 절감하고 업무의 신속성을 높입니다.',
    },
    {
      no: '03',
      icon: '👑',
      title: '전문성 (Expertise)',
      desc: '분야별 최고의 전문 인력과 40페이지 분량의 표준화 매뉴얼로 최상의 서비스를 제공합니다. 다수의 면허와 자격을 보유한 핵심 인력이 함께합니다.',
    },
    {
      no: '04',
      icon: '❤️',
      title: '고객 중심 (Customer First)',
      desc: '고객의 needs를 최우선으로 생각하며, 만족을 넘어 감동을 전합니다. TSI 만족도 조사를 통해 서비스를 지속적으로 개선합니다.',
    },
  ],
  commitments: [
    '입주 초기부터 안정적인 관리 운영을 보장하는 예방 중심의 자산관리',
    '투명한 회계 처리와 정기적인 재무 보고를 통한 신뢰 경영',
    '에너지 최적화와 원가 분석을 통한 합리적인 비용 관리',
    '감염병 예방과 위생 관리를 통한 안전하고 쾌적한 생활환경 조성',
  ],
};

export const managementCycle = [
  {
    step: '01',
    title: 'Facility Management',
    desc: '시설물 유지보수, 관리, 에너지 효율화',
  },
  {
    step: '02',
    title: 'Property Management',
    desc: '효율적 운영을 통한 자산가치 극대화',
  },
  {
    step: '03',
    title: 'Asset Management',
    desc: '부동산 자산가치와 주주가치 동시 향상',
  },
  {
    step: '04',
    title: 'Real Estate Consulting',
    desc: '매입에서 매각에 이르는 전 과정 관리',
  },
];

export const tsiProcess = [
  { name: '설문지 구성', icon: '📝' },
  { name: '조사 실시', icon: '📊' },
  { name: '결과 분석', icon: '📈' },
  { name: '개선안 수립', icon: '💡' },
  { name: 'Feed Back', icon: '🔄' },
];